// const grid = document.querySelector<HTMLElement>('.header-section__grid');
// if (grid) {
//   const elements = {
//     left: { el: grid.querySelector<HTMLElement>('.header-section__image-left'), factor: 0.02 },
//     right: { el: grid.querySelector<HTMLElement>('.header-section__image-right'), factor: 0.03 },
//     bottomRight: { el: grid.querySelector<HTMLElement>('.header-section__image-bottom-right'), factor: 0.025 },
//   };

//   grid.addEventListener('mousemove', (e) => {
//     const rect = grid.getBoundingClientRect();

//     // Mausposition relativ zur Mitte des Grids
//     const x = (e.clientX - rect.left) - rect.width / 2;
//     const y = (e.clientY - rect.top) - rect.height / 2;

//     Object.values(elements).forEach(({ el, factor }) => {
//       if (!el) return;
//       // Entgegengesetzte Richtung = negatives Vorzeichen
//       const moveX = -(x * factor);
//       const moveY = -(y * factor);
//       el.style.transform = `translate(${moveX}px, ${moveY}px)`;
//     });
//   });

//   // Zurück zur Ausgangsposition wenn Maus das Grid verlässt
//   grid.addEventListener('mouseleave', () => {
//     Object.values(elements).forEach(({ el }) => {
//       if (!el) return;
//       el.style.transition = 'transform 0.5s ease';
//       el.style.transform = 'translate(0px, 0px)';
//     });
//   });

//   grid.addEventListener('mouseenter', () => {
//     Object.values(elements).forEach(({ el }) => {
//       if (!el) return;
//       el.style.transition = 'transform 0.1s ease-out';
//     });
//   });
// }

function initParallaxGrid(gridSelector: string, elements: Record<string, { selector: string; factor: number }>) {
  const grid = document.querySelector<HTMLElement>(gridSelector);
  if (!grid) return;

  const targets = Object.fromEntries(
    Object.entries(elements).map(([key, { selector, factor }]) => [
      key,
      { el: grid.querySelector<HTMLElement>(selector), factor },
    ])
  );

  grid.addEventListener('mousemove', (e) => {
    const rect = grid.getBoundingClientRect();
    const x = (e.clientX - rect.left) - rect.width / 2;
    const y = (e.clientY - rect.top) - rect.height / 2;

    Object.values(targets).forEach(({ el, factor }) => {
      if (!el) return;
      el.style.transform = `translate(${-(x * factor)}px, ${-(y * factor)}px)`;
    });
  });

  grid.addEventListener('mouseleave', () => {
    Object.values(targets).forEach(({ el }) => {
      if (!el) return;
      el.style.transition = 'transform 0.5s ease';
      el.style.transform = 'translate(0px, 0px)';
    });
  });

  grid.addEventListener('mouseenter', () => {
    Object.values(targets).forEach(({ el }) => {
      if (!el) return;
      el.style.transition = 'transform 0.1s ease-out';
    });
  });
}

// Header
initParallaxGrid('.header-section__grid', {
  left: { selector: '.header-section__image-left', factor: 0.02 },
  right: { selector: '.header-section__image-right', factor: 0.03 },
  bottomRight: { selector: '.header-section__image-bottom-right', factor: 0.025 },
});

// Pinboard
initParallaxGrid('.pinboard-grid', {
  stickerLeft: { selector: '.pinboard-grid__sticker-left', factor: 0.04 },
  stickerMiddle: { selector: '.pinboard-grid__sticker-middle', factor: 0.035 },
  stickerRight: { selector: '.pinboard-grid__sticker-right', factor: 0.045 },
});


